import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { dayAndMonth, weekdayShort } from '../calendar/calendarFormat';

/** Ein Kasten im Prüfschritt: Bernstein für den Wechsel in die Hand, Papier für „schon manuell“. */
export function MonthReviewBox({
  tone,
  title,
  children,
}: {
  tone: 'amber' | 'paper';
  title: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'rounded-tile flex flex-col gap-1 p-3.5',
        tone === 'amber' ? 'bg-amber-tint' : 'bg-paper',
      )}
    >
      <span className={cn('text-sm font-bold', tone === 'amber' ? 'text-amber-ink' : 'text-ink')}>
        {title}
      </span>
      <span className="text-ink-soft text-[13px]">{children}</span>
    </div>
  );
}

export function countDays(value: number) {
  return `${value} ${value === 1 ? 'Tag' : 'Tage'}`;
}

/** Tage aus dem geladenen Fenster, höchstens sechs; die Zahl darüber kommt vom Server. */
export function listDays(dates: readonly string[]) {
  if (dates.length === 0) return '';
  const shown = dates.slice(0, 6).map((date) => `${weekdayShort(date)} ${dayAndMonth(date)}`);
  return `${shown.join(', ')}${dates.length > 6 ? ' …' : ''} – `;
}
